import { render } from "./AddButtonComponent.vue?vue&type=template&id=798d9180&scoped=true"
import script from "./AddButtonComponent.vue?vue&type=script&lang=js"
export * from "./AddButtonComponent.vue?vue&type=script&lang=js"

import "./AddButtonComponent.vue?vue&type=style&index=0&id=798d9180&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798d9180"]])

export default __exports__